import styled from 'styled-components'
import theme from '../../styles/theme.css'

export const ContainerMore = styled.div`
    width: 100%;
    max-width: 940px;
    margin: 2rem auto;
    display: grid;
    grid-template-areas: 'imagen1 imagen2 imagen3';
    grid-gap: 10px;
    
    img{
        max-width: 100%;
        height: 200px;
        object-fit: cover;
        @media (max-width: 764px){
            height: 100px;
        }
    }
    a{
        text-decoration: none;
    }
    p{
        font-size: 1rem;
        font-family: ${theme.plexMono};
        font-weight: 800;
        text-align: center;
        color: #FFFFFF;
        margin: 0;
        @media (max-width: 680px){
            font-size: 0.7rem;
    }
    }
    .item1 {
        grid-area: "imagen1";
    }
    .item2 {
        grid-area: "imagen2";
    }
    .item3 {
        grid-area: "imagen3";
    }
`